import UserList from './List.vue'
import UserCreate from './Create.vue';
import UserView from './View.vue';
import AppContainer from '@/container/AppContainer.vue';

export const routes = [
    {
        path: '/users',
        name: 'users',
        component: AppContainer,
        children: [
            {
                path: 'new',
                component: UserCreate,
                meta: {
                    title: "New User"
                }
            },
            {
                path: ':id',
                component: UserView,
                meta: {
                    title: "User"
                }
            },
            {
                path: '/',
                component: UserList,
                meta: {
                    title: "Users"
                }
            }
        ]
    }
]
